import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const hrApi = {
  // Employees
  listEmployees: (params) => api.get('/employees', { params }).then(unwrap),
  getEmployee: (id) => api.get(`/employees/${id}`).then(unwrap),
  getMyEmployee: () => api.get('/employees/me').then(unwrap),
  createEmployee: (payload) => api.post('/employees', payload).then(unwrap),
  updateEmployee: (id, patch) => api.patch(`/employees/${id}`, patch).then(unwrap),
  deleteEmployee: (id) => api.delete(`/employees/${id}`).then(unwrap),
  orgChart: (root) => api.get('/employees/org-chart', { params: root ? { root } : {} }).then(unwrap),

  // Documents
  listDocuments: (id) => api.get(`/employees/${id}/documents`).then(unwrap),
  uploadDocument: (id, file, meta = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    if (meta.type) fd.append('type', meta.type);
    if (meta.name) fd.append('name', meta.name);
    if (meta.expiryDate) fd.append('expiryDate', meta.expiryDate);
    return api.post(`/employees/${id}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(unwrap);
  },

  // Skills
  listSkills: (id) => api.get(`/employees/${id}/skills`).then(unwrap),

  // Positions / Departments
  listPositions: (params) => api.get('/positions', { params }).then(unwrap),
  createPosition: (payload) => api.post('/positions', payload).then(unwrap),
  listDepartments: (params) => api.get('/departments', { params }).then(unwrap),
  createDepartment: (payload) => api.post('/departments', payload).then(unwrap),

  // Attendance
  attendanceToday: (employeeId) => api.get('/attendance/today', { params: employeeId ? { employee_id: employeeId } : {} }).then(unwrap),
  clockIn: () => api.post('/attendance/clock-in', {}).then(unwrap),
  clockOut: () => api.post('/attendance/clock-out', {}).then(unwrap),
  timesheet: (params) => api.get('/attendance', { params }).then(unwrap),

  // Leave
  leaveTypes: () => api.get('/leave/types').then(unwrap),
  leaveRequests: (params) => api.get('/leave/requests', { params }).then(unwrap),
  createLeaveRequest: (payload) => api.post('/leave/requests', payload).then(unwrap),
  decideLeave: (id, decision, notes) => api.post(`/leave/requests/${id}/decision`, { decision, notes }).then(unwrap),
  cancelLeave: (id) => api.post(`/leave/requests/${id}/cancel`, {}).then(unwrap),
  leaveBalance: (employeeId, year) => api.get(`/leave/balance/${employeeId}`, { params: year ? { year } : {} }).then(unwrap),

  // Payroll
  payrollRuns: () => api.get('/payroll/runs').then(unwrap),
  createPayrollRun: (periodMonth, periodYear, notes) => api.post('/payroll/runs', { periodMonth, periodYear, notes }).then(unwrap),
  payrollPreview: (id) => api.get(`/payroll/runs/${id}/preview`).then(unwrap),
  processPayroll: (id) => api.post(`/payroll/runs/${id}/process`).then(unwrap),
  payrollItems: (id) => api.get(`/payroll/runs/${id}/items`).then(unwrap),
  generatePayslip: (itemId) => api.post(`/payroll/items/${itemId}/generate-payslip`).then(unwrap),
  payslipsForEmployee: (employeeId) => api.get(`/payroll/payslips/${employeeId}`).then(unwrap),
  salaryStructures: () => api.get('/payroll/structures').then(unwrap),

  // Performance
  reviews: (params) => api.get('/performance/reviews', { params }).then(unwrap),
  saveReview: (payload) => (payload.id ? api.patch(`/performance/reviews/${payload.id}`, payload).then(unwrap) : api.post('/performance/reviews', payload).then(unwrap)),
  acknowledgeReview: (id) => api.post(`/performance/reviews/${id}/acknowledge`).then(unwrap),
  employeeKpis: (employeeId, period) => api.get(`/performance/employees/${employeeId}/kpis`, { params: period ? { period } : {} }).then(unwrap),
  saveEmployeeKpi: (employeeId, payload) => api.put(`/performance/employees/${employeeId}/kpis`, payload).then(unwrap),
  trainingForEmployee: (employeeId) => api.get(`/performance/training/employees/${employeeId}`).then(unwrap),
};
